/* eslint-disable no-console */
import { handleErrors } from './ErrorActions';
import * as documentApi from '../api/document';

export const FETCH_DOCUMENT_COLLABORATION = 'DocumentCollaboration/FETCH_DOCUMENT_COLLABORATION';
export const FETCH_DOCUMENT_COLLABORATION_SUCCESS =
  'DocumentCollaboration/FETCH_DOCUMENT_COLLABORATION_SUCCESS';

export const getDocumentCollaborationSuccess = (data) => ({
  type: FETCH_DOCUMENT_COLLABORATION_SUCCESS,
  payload: { data },
});

export const getDocumentCollaboration = (params) => async (dispatch) => {
  dispatch({
    type: FETCH_DOCUMENT_COLLABORATION,
  });

  try {
    const apiData = await documentApi.getOnlineCollaboration(params);

    if (apiData.hasError) {
      dispatch(handleErrors(apiData.errors));
      return;
    }

    dispatch(getDocumentCollaborationSuccess(apiData.Result));
  } catch (error) {
    console.log(`documentCollaboration() failed: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error));
  }
};

export const getSharePointUrl = (documentData) => async (dispatch) => {
  try {
    const response = await documentApi.getSharePointUrl(documentData);

    if (response.hasError) {
      dispatch(handleErrors(response.errors));
      return;
    }

    return response.Result;
  } catch (error) {
    console.log(`sharePointUrl() failed: ${JSON.stringify(error)}`);
  }
};
